<template>
	<v-tabs
		class="question-type-selector"
		v-model="selectedQuestionTypeIndex"
		@change="handleQuestionsTypeChange($event)"
	>
		<v-tab v-for="(questionType, index) in QUESTION_TYPES" :key="index">
			<b>{{ questionType.label }}</b>
		</v-tab>
	</v-tabs>
</template>
<script>
import { findIndex, prop, propEq } from 'ramda';
import { QUESTION_TYPES } from '../../../constants/labels.constant';

export default {
	name: 'question-type-selector',
	props: ['questionsType'],
	data() {
		return {
			QUESTION_TYPES,
			selectedQuestionTypeIndex: 1, // change to 0 to initialize in first person
		};
	},
	methods: {
		handleQuestionsTypeChange(index) {
			this.$emit('questionTypeChanged', prop(index, QUESTION_TYPES));
		},
	},
	watch: {
		questionsType: {
			handler(newValue) {
				if (!newValue) {
					this.selectedQuestionTypeIndex = 0;
					this.handleQuestionsTypeChange(1); // change to 0 to initialize in first person
					return;
				}
				this.selectedQuestionTypeIndex = findIndex(propEq('key', newValue.key), QUESTION_TYPES);
			},
			immediate: true,
		},
	},
};
</script>

<style lang="scss">
.question-type-selector {
	.v-tabs__bar {
		background: transparent;

		.v-tabs__slider-wrapper {
			.accent {
				background: var(--app-color-primary) !important;
			}
		}

		.v-tabs__container {
			height: 30px !important;

			.v-tabs__div {
				color: var(--app-color-primary) !important;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/three-sixty-evaluation/components/third-step/components/question-type-selector.vue